import { Record, Map } from "immutable"

import {
    toUI as defaultToUI,
    normaliseModel,
    hydrateModel,
    updateChangeModel,
    updateCreateModel,
} from "../model-utils"
import moment from "moment"
import {
    defaultContentType,
    sourceTypes,
    licenseOptions,
    publicationTypes,
} from "../../config/application-definitions"

export const SourceModel = new Record({
    id: "",
    active: false,
    auto_approved: "",
    content_type: defaultContentType,
    country: "",
    description: "",
    display_name: "",
    favicon: "",
    language: "",
    license: licenseOptions[0],
    link_pattern: "",
    listing_urls: [],
    name: "",
    preserve_article_links: false,
    publication_type: publicationTypes[0],
    region: "",
    source_request_error_count: 0,
    topics: [],
    type: sourceTypes[0],
    updated: moment(),
    imagePreviewURL: undefined,
    url: "",
})

export function SourceCreateModel() {
    return Map({
        active: true,
        content_type: defaultContentType,
        description: "",
        license: licenseOptions[0],
        publication_type: publicationTypes[0],
        name: "",
        source_request_error_count: 0,
        type: sourceTypes[0],
        url: "",
    })
}

const dateFields = ["updated"]
const tagFields = []
export const normalisingFields = ["topics"]
const addRemoveFields = ["topics"]

export const normalise = (source) =>
    normaliseModel(source, ...normalisingFields)
export const hydrate = (source, ...entityStates) =>
    hydrateModel(source, normalisingFields, entityStates)

export const updateSourceChangeModel = (
    name,
    value,
    changeModel,
    workingModel
) => updateChangeModel(name, value, changeModel, workingModel, addRemoveFields)

export const updateSourceCreateModel = (
    name,
    value,
    createModel,
    workingModel
) => updateCreateModel(name, value, createModel, workingModel, addRemoveFields)

export const toUI = (source) => defaultToUI(source, dateFields, tagFields)
